"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormSettingsStore from "Stores/Forms/FormSettingsStore";
import { formSettingsInitialize } from "Actions/Forms/FormSettingsActions";
import { Messages } from "Messages";
import { formSubmit, navigateToParent } from "Actions/Forms/FormActions";

var styles = function styles(theme) {
  return {};
};

var FormSettings =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormSettings, _React$Component);

  function FormSettings(props) {
    var _this;

    _classCallCheck(this, FormSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormSettings).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = FormSettingsStore.getInitList();
    return _this;
  }

  _createClass(FormSettings, [{
    key: "_onChange",
    value: function _onChange() {
      this.setState(FormSettingsStore.getList(this.props.UUID));
    }
  }, {
    key: "_onCancelClick",
    value: function _onCancelClick() {
      navigateToParent(this.props.UUID);
    }
  }, {
    key: "_onApplyClick",
    value: function _onApplyClick() {
      formSubmit(this.props.UUID);
    }
  }, {
    key: "initForm",
    value: function initForm() {
      var _this2 = this;

      $(this.scrollView).dxScrollView({
        height: '100%',
        width: '100%',
        elementAttr: {
          id: "fscrl-".concat(this.props.UUID)
        },
        scrollByContent: true,
        scrollByThumb: true,
        showScrollbar: "always"
      });
      this.instanceForm = this.formEl;
      this.initOwner();
      var instances = {
        form: this.instanceForm,
        popup: this.popupInstance
      };
      setTimeout(function () {
        return formSettingsInitialize(_this2.props.formObj, instances);
      });
    }
  }, {
    key: "initOwner",
    value: function initOwner() {
      var _this3 = this;

      var title = this.props.formObj.title;
      var UUID = this.props.UUID;
      var caption = title || 'Settings';
      this.popupInstance = this.$popupEl.dxPopup({
        dragEnabled: true,
        showTitle: true,
        tabIndex: -1,
        closeOnOutsideClick: false,
        width: 'auto',
        height: 'auto',
        maxHeight: '100%',
        maxWidth: '100%',
        minHeight: '300px',
        minWidth: '500px',
        position: {
          my: 'center',
          at: 'center',
          of: 'body'
        },
        onShown: function onShown(e) {
          $("#fscrl-".concat(UUID)).find('.dx-scrollable-container').attr('tabIndex', -1);
        },
        contentTemplate: function contentTemplate(container) {
          container.append(_this3.scrollView);
          return container.append(_this3.scrollView);
        },
        onHidden: function onHidden() {
          $('.d5-popover').remove();
          navigateToParent(UUID);
        },
        titleTemplate: function titleTemplate(titleElement) {
          titleElement.append("<div class='form-title' ><span id=\"fe-title-".concat(UUID, "\">").concat(caption, "</span><div/>"));
          titleElement.find('.form-title').append(_this3.createButtonPanel());
          return titleElement;
        }
      });
    }
  }, {
    key: "createButtonPanel",
    value: function createButtonPanel() {
      var apply = $("<div class=\"title-button\"  tabIndex=\"-1\">".concat(Messages.Controls.Apply, "</div>"));
      var cancel = $("<div class=\"title-button\"  tabIndex=\"-1\">".concat(Messages.Controls.Cancel, "</div>"));
      apply.on('click', this._onApplyClick.bind(this));
      cancel.on('click', this._onCancelClick.bind(this));
      return $("<div class=\"form-buttons-panel\"/>").append(apply).append(cancel);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      FormSettingsStore.addChangeListener(this._onChange);
      this.initForm();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      FormSettingsStore.removeChangeListener(this._onChange);
      if (this.popupInstance) this.popupInstance.remove();
      FormSettingsStore.destroy(this.props.UUID);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return React.createElement("div", {
        style: {
          height: '100%',
          padding: '16px'
        }
      }, React.createElement("div", {
        ref: function ref(r) {
          return _this4.$popupEl = $(r);
        },
        style: {
          height: '100%',
          backgroundColor: '#ffffff'
        }
      }, React.createElement("div", {
        className: "scroll-view",
        ref: function ref(r) {
          return _this4.scrollView = r;
        }
      }, React.createElement("div", {
        id: "settings-from",
        className: 'form',
        ref: function ref(r) {
          return _this4.formEl = r;
        },
        style: {
          padding: '20px'
        }
      }))));
    }
  }]);

  return FormSettings;
}(React.Component);

_defineProperty(FormSettings, "propTypes", {
  classes: PropTypes.object.isRequired,
  UUID: PropTypes.string.isRequired,
  isActive: PropTypes.bool
});

_defineProperty(FormSettings, "defaultProps", {
  formID: "".concat(Math.floor(Math.random() * 1000)),
  isActive: false
});

export default withStyles(styles)(FormSettings);